
const state = {}

const getters = {}

const actions = {

  async parseRoute({ commit, dispatch, getters, rootState }, route) {
    if (route.name == 'equipmentmodelsbytype'
            || route.name == 'equipmentbymodel'
            || route.name == 'inspections'
            || route.name == 'signin') {
      if (!getters.equipmentType.Code && route.params.equipmentTypeId) {
        await dispatch('updateEquipmentTypeItems')
        const currentType = rootState.eqType.equipmentTypeItems.find(t => t.Code == route.params.equipmentTypeId)
        if (currentType) {
          commit('setEquipmentType', currentType)
          await dispatch('updateEquipmentModelItems', {
            groupCode: currentType.Code
          })
        }
      }
    }
  }
}

const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}